

export class DeviceModelPortSpecificationOutputData implements IDeviceModelPortSpecificationOutputData {
    /** The auto-generated id of the device model port specification  master */
    device_model_port_specification_id!: number;
    /** The property name with 255 character limit */
    property_name!: string;

    constructor(data?: IDeviceModelPortSpecificationOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.property_name = _data["property_name"];
        }
    }

    static fromJS(data: any): DeviceModelPortSpecificationOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortSpecificationOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["property_name"] = this.property_name;
        return data; 
    }
}

export interface IDeviceModelPortSpecificationOutputData {
    /** The auto-generated id of the device model port specification  master */
    device_model_port_specification_id: number;
    /** The property name with 255 character limit */
    property_name: string;
}

